import { Select, SelectProps } from '@mui/material'
import React from 'react'

const SelectWrapper: React.FC<SelectProps> = ({ ...props }) => (
  <Select {...props}></Select>
)

export default SelectWrapper
